import { RouteConfig } from "vue-router";
import { getLoginData } from "@/lib/authHelper";
import { enrichRouteMeta } from "@/router/helpers";
import PageEmailConfirm from "@/views/PageEmailConfirm";
import PageEmailConfirmCode from "@/views/PageEmailConfirmCode";
import PageForgotPassword from "@/views/PageForgotPassword";
import PageForgotPasswordConfirmCode from "@/views/PageForgotPasswordConfirmCode";
import PageForgotPasswordSet from "@/views/PageForgotPasswordSet";
import PageLogin from "@/views/PageLogin";
import PageLoginTwitter from "@/views/PageLoginTwitter";
import PageSignUp from "@/views/PageSignUp";

const routes: RouteConfig[] = [
  {
    path: "/login",
    name: "login",
    component: PageLogin,
  },
  {
    path: "/login/forgot",
    name: "loginForgot",
    component: PageForgotPassword,
  },
  {
    path: "/login/forgot/:email",
    name: "loginForgotEmail",
    component: PageForgotPasswordConfirmCode,
    props: true,
  },
  {
    path: "/login/forgot/:email/:token",
    name: "loginForgotSet",
    component: PageForgotPasswordSet,
    props: true,
  },
  {
    path: "/signup",
    name: "signup",
    component: PageSignUp,
  },
  {
    path: "/signup/confirm",
    name: "signupConfirm",
    component: PageEmailConfirmCode,
    props: route => ({ code: route.query.code }),
    beforeEnter(to, from, next) {
      const data = getLoginData();
      if (!data && !to.query.code) next(false);
      else next();
    },
  },
  {
    path: "/signup/email",
    name: "signupEmailConfirm",
    component: PageEmailConfirm,
    meta: { private: true },
  },
  {
    path: "/login/twitter",
    name: "loginTwitter",
    component: PageLoginTwitter,
    props: route => {
      return { queryString: route.query };
    },
  },
];

export default routes.map(route => enrichRouteMeta(route, { login: true }));
